import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE, MASK_DATE_YYYYMMDD_HHMM, MASK_MONEY, MASK_TEXT_NOWRAP } from "../../../../../../theme/Component/BasicTable";
import { _ImportRegistry, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { DropDown } from "../../../../../../theme/Component/DropDown";
import useModal, { MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import AutoChart from "../../../../../../../core/graph/AutoChart";
import { Modal } from "../../../../../../theme/Component/Modal";

type filterProps = {
    Year: number;
    State: number;
    LoteNumber: string;
    ContractNumber: string;
    CompanyName: string;
    ContractObject: string;
    DeclarationNumber: string;
    DeclarationDate: string;
    CargoManifest: string;
    CargoManifestDate: string;
    TransportDocument: string;
    ExporterName: string;
    TaxCode: string;
}

export const MatrixImportNationalization = () => {

    const { instance, lista, setBean, bean, setLista } = useDataBean(_ImportRegistry);
    const paginador = usePaginator();

    const modalGraph = useModal("Gráfica de nacionalización", MODAL_XL);

    const [filter, setFilter] = useState<Partial<filterProps>>({
        // Year: _single.getCurrenYear(),
        State: 1,
    })

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getImportDeclarationReport(paginador.page, 15, _single.cleanMap(filter)).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15);
                setLista(resp.List)
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'No. Lote', property: 'LoteNumber', visible: true },
        { title: 'Contrato', property: 'ContractNumber' },
        { title: 'Objeto de Contrato', property: 'ContractObject', visible: false, Style: { minWidth: "350px" } },
        { title: 'Empresa', property: 'CompanyName' },
        { title: 'FECHA', property: 'Since', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'DECLARACIÓN No.', property: 'DeclarationNumber', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'AUTOADHESIVO', property: 'Autoahesivo', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'TIPO DE DECLARACIÓN', property: 'TypeDeclarationName', visible: true },
        { title: 'No. ACEPTACIÓN DECLARACIÓN', property: 'AceptDeclaration', visible: true },
        { title: 'FECHA DE DECLARACION', property: 'DeclarationDate', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'DEPÓSITO ADUANERO', property: 'BondedWarehouse', visible: true },
        { title: 'MANIFIESTO DE CARGA', property: 'CargoManifest', visible: true },
        { title: 'FECHA DE MANIFIESTO', property: 'CargoManifestDate', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'DOCUMENTO DE TRANSPORTE', property: 'TransportDocument', visible: true },
        { title: 'EXPORTADOR', property: 'ExporterName', visible: true },
        { title: 'MODO DE TRANSPORTE', property: 'TransportModeName', visible: true },
        { title: 'TASA DE CAMBIO', property: 'ExchangeRate', visible: true },
        { title: 'MODALIDAD', property: 'ModalityName', visible: true },
        { title: 'TIPO DE IMPORTACIÓN', property: 'ImportTypeName', visible: true },
        { title: 'POSICIÓN ARANCELARIA', property: 'TaxCode', visible: true },
        { title: 'FORMA DE PAGO', property: 'PaymentTypeName', visible: true },
        { title: 'PESO BRUTO', property: 'GrossWeightDI', visible: true },
        { title: 'CANTIDAD', property: 'Quantity', visible: true },
        { title: 'UNIDAD COMERCIAL', property: 'UnitName', visible: true },
        { title: 'VALOR FOB', property: 'VrFOB', visible: true, mask: MASK_MONEY },
        { title: 'FLETES Y SEGUROS', property: 'VrFlete', visible: true, mask: MASK_MONEY },
        { title: 'VALOR CIF DÓLARES', property: 'VrCIFDolar', visible: true, mask: MASK_MONEY },
        { title: 'VALOR CIF PESOS', property: 'VrCIFPesos', visible: true, mask: MASK_MONEY },
        { title: 'LICENCIA', property: 'LicenceNumber', visible: true },
        { title: 'VALOR GRAVÁMENES PAGADOS', property: 'VrTotalFob', visible: true, mask: MASK_MONEY },
        { title: 'IVA', property: 'TaxPercentage', visible: true, mask: MASK_MONEY },
        { title: 'OBSERVACIONES', property: 'Observation', visible: true },
        { title: 'DESTINO', property: 'DestinityName', visible: true },
        { title: 'ACTA No.', property: 'ActaNumber', visible: true },
        { title: 'DESCRIPCIÓN', property: 'DescriptionItem', visible: true },
    ];


    const actionsDropDown = [
        { id: 1, name: 'Reporte Grafico', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        )
    }
    const actions = (e: any) => {

        if (e.id === 1) {
            modalGraph.open();
        }
    }

    const search = () => {
        if (paginador.page !== 1) {
            paginador.setPage(1);
            return;
        }

        getLista();
    }

    return (
        <BasicPage titulo="Reporte Nacionacionalización">
            <div className="row">
                <div className="col-md-3">
                    <label>No. Lote</label>
                    <input type="text" className="form-control" value={filter.LoteNumber ?? ""} onChange={(e) => { setFilter({ ...filter, LoteNumber: e.target.value }) }} />
                </div>
                <div className="col-md-3">
                    <label>Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractNumber ?? ""} onChange={(e) => { setFilter({ ...filter, ContractNumber: e.target.value }) }} />
                </div>
                <div className="col-md-3">
                    <label>Empresa</label>
                    <input type="text" className="form-control" value={filter.CompanyName ?? ""} onChange={(e) => { setFilter({ ...filter, CompanyName: e.target.value }) }} />
                </div>
                <div className="col-md-3">
                    <label>No. Declaración</label>
                    <input type="text" className="form-control" value={filter.DeclarationNumber ?? ""} onChange={(e) => { setFilter({ ...filter, DeclarationNumber: e.target.value }) }} />
                </div>

                <div className="col-md-3 mt-2">
                    <label>Fecha de declaración</label>
                    <input type="date" className="form-control" value={filter.DeclarationDate ?? ""} onChange={(e) => { setFilter({ ...filter, DeclarationDate: e.target.value }) }} />
                </div>
                <div className="col-md-3 mt-2">
                    <label>Manifiesto de carga</label>
                    <input type="text" className="form-control" value={filter.CargoManifest ?? ""} onChange={(e) => { setFilter({ ...filter, CargoManifest: e.target.value }) }} />
                </div>
                <div className="col-md-3 mt-2">
                    <label>Fecha de manifiesto</label>
                    <input type="date" className="form-control" value={filter.CargoManifestDate ?? ""} onChange={(e) => { setFilter({ ...filter, CargoManifestDate: e.target.value }) }} />
                </div>
                <div className="col-md-3 mt-2">
                    <label>Documento de transporte</label>
                    <input type="text" className="form-control" value={filter.TransportDocument ?? ""} onChange={(e) => { setFilter({ ...filter, TransportDocument: e.target.value }) }} />
                </div>

                <div className="col-md-3 mt-2">
                    <label>Exportador</label>
                    <input type="text" className="form-control" value={filter.ExporterName ?? ""} onChange={(e) => { setFilter({ ...filter, ExporterName: e.target.value }) }} />
                </div>
                <div className="col-md-3 mt-2">
                    <label>Posición arancelaria</label>
                    <input type="text" className="form-control" value={filter.TaxCode ?? ""} onChange={(e) => { setFilter({ ...filter, TaxCode: e.target.value }) }} />
                </div>
                <div className="col-md-3 mt-2">
                    <label>Objeto del contrato</label>
                    <input type="text" className="form-control" value={filter.ContractObject ?? ""} onChange={(e) => { setFilter({ ...filter, ContractObject: e.target.value }) }} />
                </div>
                <div className="col-md-3 d-flex align-items-end">
                    <BasicButton eventClick={search} icon="ri-search-line" children={"Buscar"} useMargin />
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} records={paginador} />
                </div>

                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <AutoChart
                        data={lista}
                        head={head}
                        useIndexAsXLabel={false}
                        exportFileName="reporte_nacionalizacion"
                        xOptions={[
                            'DescriptionItem',
                            'LoteNumber',
                            'ContractNumber',
                            'CompanyName',
                            'DeclarationNumber',
                            'DeclarationDate',
                            'TypeDeclarationName',
                            'BondedWarehouse',
                            'CargoManifest',
                            'CargoManifestDate',
                            'TransportDocument',
                            'ExporterName',
                            'TransportModeName',
                            'ModalityName',
                            'ImportTypeName',
                            'TaxCode',
                            'PaymentTypeName',
                            'UnitName',
                        ]}
                        yOptions={[
                            'ExchangeRate',
                            'GrossWeightDI',
                            'Quantity',
                            'VrFOB',
                            'VrFlete',
                            'VrCIFDolar',
                            'VrCIFPesos',
                            'VrTotalFob',
                            'TaxPercentage',
                        ]}
                    />
                </Modal>
            </div>
        </BasicPage >
    )
}
